export const CEntryModalFragments = {
  field: `
    fragment entryModal on entryModal_MatrixField {
      ... on entryModal_block_Entry {
        __typename
        headline
        wysiwyg
        buttonLabel
        buttonUrl
        delayShow
        delayTime
        closeFrequency
      }
    }
  `,
}
